import { Route } from '@angular/router';

export const personnelRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./list/personnel-list.component').then(
            (m) => m.PersonnelListComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/personnel-detail.component').then(
            (m) => m.PersonnelDetailComponent
          ),
      },
      {
        path: 'edit/:expertId',
        loadComponent: () =>
          import('./detail/personnel-detail.component').then(
            (m) => m.PersonnelDetailComponent
          ),
      },
    ],
  },
];
